import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MppSpinnerComponent } from './spinner.component';

@NgModule({
  imports: [CommonModule],
  declarations: [MppSpinnerComponent],
  exports: [MppSpinnerComponent],
})
export class MppSpinnerModule {}
